module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NbPagerSelection', {
    attrs: {
      "pager": _vm.pager,
      "activeItem": _vm.activeArticle
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.activeArticle.title ? "#" + _vm.activeArticle.id + " " + _vm.activeArticle.title : "请选择文章...") + "\n\t\t")]), _vm._v(" "), _vm._l((_vm.pager.articles), function(article) {
    return _c('div', {
      staticClass: "mb10 p10 cursor br4 border",
      class: {
        'bg-white': article.id !== _vm.activeArticle.id, 'bg-azure': article.id === _vm.activeArticle.id
      },
      attrs: {
        "slot": "cells"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.clickItem(article)
        }
      },
      slot: "cells"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [(article.poster && article.poster.url) ? _c('img', {
      staticClass: "img-rounded img-md",
      attrs: {
        "src": article.poster.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('div', [_c('span', {
      staticClass: "label",
      class: 'label-' + article.TypeMap[article.type].style
    }, [_vm._v(_vm._s(article.TypeMap[article.type].name))]), _vm._v(" "), _c('span', {
      staticClass: "f15 nb-a"
    }, [_vm._v(_vm._s(article.title))])]), _vm._v(" "), _c('div', {
      staticClass: "mt5"
    }, [_c('span', {
      staticClass: "mr10"
    }, [_vm._v("#" + _vm._s(article.id))]), _vm._v(" "), _c('span', {
      staticClass: "mr10"
    }, [_vm._v("创建于:" + _vm._s(_vm._f("simpleDateTime")(article.createTime)))]), _vm._v(" "), _c('span', {
      staticClass: "mr10"
    }, [_vm._v("阅读:" + _vm._s(article.hit))]), _vm._v(" "), _c('span', {
      staticClass: "mr10"
    }, [_vm._v("作者:" + _vm._s(article.author))])])])])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-d7aeb458"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/article/Selection.vue
// module id = 1029
// module chunks = 1